import { render, staticRenderFns } from "./OrgTree.vue?vue&type=template&id=e1ae24dc&"
import script from "./OrgTree.vue?vue&type=script&lang=js&"
export * from "./OrgTree.vue?vue&type=script&lang=js&"
import style0 from "./OrgTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports